module.exports = __webpack_public_path__ + "static/media/standard.cbd061f4.svg";